export const formatHoursLabel = (minutes: number): string => {
  const totalMinutes = Number.isFinite(minutes) ? Math.max(0, minutes) : 0;
  const hours = totalMinutes / 60;
  const rounded = Math.round(hours * 10) / 10;
  const roundedStr = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  const isSingular = rounded === 1;

  return `${roundedStr} ${isSingular ? "hour" : "hours"}`;
};
